// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner-module--banner--3MhiS","margin":"Banner-module--margin--3KS4E","secondary":"Banner-module--secondary--Cnl-D","text":"Banner-module--text--1CuYu"};